import React from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Typography,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import * as premiumApi from "../../api/premiumApi";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import swal from "sweetalert";
import ScrollToTopBtn from "../common/ScrollToTop";

class VintageListAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vintages: [],
      member: "tff",
      userRoles: [],
      page: 0,
      rowsPerPage: 10,
    };
  }

  async componentDidMount() {
    try {
      const currentUser = JSON.parse(sessionStorage.getItem("token"));
      if (currentUser) {
        const userRoles = currentUser.userRoles.map((r) => r.roleName);
        this.setState({ userRoles });
      }
      this.getVintages();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getVintages = async () => {
    const vintages = await premiumApi.getVintages(this.state.member);
    if (vintages) {
      vintages.sort((a, b) => (a.vintageYear < b.vintageYear ? 1 : -1));
      this.setState({ vintages });
    } else {
      this.setState({ vintages: [] });
    }
  };

  handleChangePage = (_event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleEndButton = async (org, year, ended) => {
    const end = !ended;
    const response = await premiumApi.endVintage(org, year, end);

    if (response === `Vintage ${year} requested opened.`) {
      swal(
        "Forespørselen din er sendt!",
        "Nå venter på en annen Admin for å bekrefte!",
        "info"
      );
    } else if (response === `Vintage ${year} is open.`) {
      swal(`Årgang ${year} er nå åpen!`, "", "success");
    }
    this.getVintages();
  };

  handleRadioButton = async (e) => {
    this.setState({ member: e.target.value }, this.getVintages);
  };

  render() {
    const layout = {
      width: "100%",
      paddingTop: 80,
    };
    const tableWrapper = {
      marginTop: 10,
      overflow: "auto",
    };
    const headStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };
    const linkStyle = {
      textDecoration: "none",
      color: "#673ab7",
    };
    const buttonStyle = {
      margin: 8,
    };

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layout}>
            <div>
              <FormControl component="fieldset" style={{ marginLeft: 10 }}>
                <RadioGroup
                  row
                  name="position"
                  defaultValue="tff"
                  onChange={this.handleRadioButton}
                >
                  <Typography variant="h6" style={{ marginRight: 16 }}>
                    Organisasjon
                  </Typography>
                  <FormControlLabel
                    value="tff"
                    control={<Radio color="primary" />}
                    label="TFF"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="yff"
                    control={<Radio color="primary" />}
                    label="YFF"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <Paper>
              <div style={tableWrapper}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" style={headStyle}></TableCell>
                      <TableCell style={headStyle}>ÅR</TableCell>
                      <TableCell align="center" style={headStyle}>
                        AVSLUTTET
                      </TableCell>
                      <TableCell style={headStyle}></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {this.state.vintages.length > 0 &&
                      this.state.vintages
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage +
                          this.state.rowsPerPage
                        )
                        .map((vintage, index) => (
                          <TableRow key={index} hover>
                            <TableCell align="center">
                              <Link
                                to={`/policyyearadmin/${this.state.member}/${vintage.vintageYear}`}
                                style={linkStyle}
                              >
                                <Button
                                  variant="outlined"
                                  size="medium"
                                  color="primary"
                                  style={buttonStyle}
                                >
                                  <ArrowForwardIosIcon style={{ marginRight: 8 }} />
                                  Vis Mer
                                </Button>
                              </Link>
                            </TableCell>

                            <TableCell>
                              <Typography>{vintage.vintageYear}</Typography>
                            </TableCell>

                            <TableCell align="center">
                              <Checkbox
                                checked={vintage.ended}
                                color="default"
                              />
                            </TableCell>

                            <TableCell>
                              {vintage.ended ? (
                                this.state.userRoles.includes("Admin") ? (
                                  !vintage.requestedOpened ? (
                                    <Button
                                      variant="outlined"
                                      size="medium"
                                      color="primary"
                                      style={buttonStyle}
                                      onClick={() =>
                                        this.handleEndButton(
                                          this.state.member,
                                          vintage.vintageYear,
                                          vintage.ended
                                        )
                                      }
                                    >
                                      <LockOpenOutlinedIcon style={{ marginRight: 8 }} />
                                      Åpne
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      size="medium"
                                      color="primary"
                                      style={buttonStyle}
                                      onClick={() =>
                                        this.handleEndButton(
                                          this.state.member,
                                          vintage.vintageYear,
                                          vintage.ended
                                        )
                                      }
                                    >
                                      <LockOpenOutlinedIcon style={{ marginRight: 8 }} />
                                      Bekreft åpning av årgang
                                    </Button>
                                  )
                                ) : null
                              ) : (
                                <Button
                                  variant="outlined"
                                  size="medium"
                                  color="secondary"
                                  style={buttonStyle}
                                  onClick={() =>
                                    this.handleEndButton(
                                      this.state.member,
                                      vintage.vintageYear,
                                      vintage.ended
                                    )
                                  }
                                >
                                  <LockOutlinedIcon style={{ marginRight: 8 }} />
                                  Avslutt
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={this.state.vintages.length}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default VintageListAdmin;
